export const EVENT_SIM_ADDREF_DIALOG_OPEN = '@simulation/OPEN_ADD_REF_DIALOG';
export const EVENT_SIM_ADDREF_DIALOG_CLOSE = '@simulation/CLOSE_ADD_REF_DIALOG';
